import type { ReactNode } from 'react';

import type { IconName } from '../../../assets/Icon/Icon';
import { Icon } from '../../../assets/Icon/Icon';
import { colors, darkThemeSelector, styled } from '../../../stitches.config';

const ChassisBracketLine = styled('div', {
  flex: 1,
  height: '$1',
  background: colors.strokeNeutralLight,
  position: 'relative',

  [darkThemeSelector]: {
    background: colors.strokeNeutralDark,
  },
});
ChassisBracketLine.displayName = 'ChassisBracketLine';

const ChassisBracketIcon = styled(Icon, {
  color: colors.accentNeutralLight,

  [darkThemeSelector]: {
    color: colors.accentNeutralDark,
  },
});
ChassisBracketIcon.displayName = 'ChassisBracketIcon';

const ChassisBracketText = styled('span', {
  whiteSpace: 'nowrap',
  color: colors.accentNeutralLight,
  fontSize: '$9',
  lineHeight: '$12',

  [darkThemeSelector]: {
    color: colors.accentNeutralDark,
  },
});
ChassisBracketText.displayName = 'ChassisBracketText';

/**
 * Sized to the ports beneath it rather than to its own label:
 * `width: 0` keeps the bracket out of the group's width
 * `minWidth: '100%'` stretches it back across whatever the ports take
 */
const ChassisBracketContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '$4',
  width: 0,
  minWidth: '100%',
});
ChassisBracketContainer.displayName = 'ChassisBracketContainer';

export type ChassisBracketProps = {
  icon?: IconName;
  label?: ReactNode;
};

export function ChassisBracket({ label, icon }: ChassisBracketProps) {
  if (!label) return null;

  return (
    <ChassisBracketContainer>
      <ChassisBracketLine />
      {icon && <ChassisBracketIcon icon={icon} size={8} />}
      <ChassisBracketText>{label}</ChassisBracketText>
      <ChassisBracketLine />
    </ChassisBracketContainer>
  );
}
